import http from '@/lib/http';

export default {
    queryMedicalOrgan(organCode, page, limit) {
        return http({
            url: page && limit ? `/officialService/queryMedicalOrgan/${organCode}/${page}/${limit}` : `/officialService/queryMedicalOrgan/${organCode}`,
        });
    },
    queryMedicalDepartment(isAll,organCode) {
        return http({
            url: `/officialService/queryMedicalDepartment/${isAll}/${organCode}`
        });
    },
    queryMedicalDoctor({
        organCode,
        departmentId
    } = {}) {
        return http({
            url: `/officialService/queryMedicalDoctor`,
            data: {
                organId: organCode,
                departmentId
            }
        });
    },
    getMedicalDoctor(shcedId) {
        return http({
            url: `/officialService/getMedicalDoctor/${shcedId}`
        });
    },
    getMedicalRecordMsg(organCode) {
        return http({
            url: `/officialService/getMedicalRecordMsg/${organCode}`
        });
    },
    queryMedicalChatRecord(page, limit, medicalRecordId) {
        return http({
            url: `/officialService/queryMedicalChatRecord/${page}/${limit}/${medicalRecordId}`
        });
    },
    sendMessage(routingKey, {
        message,
        type,
        to,
        medicalRecordId
    } = {}) {
        return http({
            url: `/officialService/sendMessage/${routingKey}`,
            data: {
                message,
                type,
                to,
                medicalRecordId
            }
        });
    },
    uploadChatImage(file) {
        let fromData = new FormData();
        fromData.append('file', file);
        return http({
            url: `/officialService/uploadChatImage`,
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            data: fromData
        });
    }
}